import { I02COSTENER_State } from '@batical/types/src'

const I02COSTENER: I02COSTENER_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_consoAnnuelle: 10000.0,
  abscisse: [],
  dataChart: [],
  maxCost: 0,
  mode: 'none',
  calcul_code: 'I02COSTENER'
}

export default I02COSTENER
